import { Grid } from "@mui/material";
import { ReferenceInput, SelectInput, useTranslate } from "react-admin";

export default function DefaultsFields() {
  const translate = useTranslate();
  return (
    <>
      <Grid item xs={12} md={4}>
        <ReferenceInput source="default_event_location" reference="event_locations">
          <SelectInput
            label={translate("settings.default_event_location.name")}
            helperText={translate("settings.default_event_location.description")}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={0} md={6} />
      <Grid item xs={12} md={4}>
        <ReferenceInput source="default_event_type" reference="event_types">
          <SelectInput
            label={translate("settings.default_event_type.name")}
            helperText={translate("settings.default_event_type.description")}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={0} md={6} />
      <Grid item xs={12} md={4}>
        <ReferenceInput source="default_price_type" reference="price_types">
          <SelectInput
            label={translate("settings.default_price_type.name")}
            helperText={translate("settings.default_price_type.description")}
          />
        </ReferenceInput>
      </Grid>
    </>
  );
}
